module.exports = __webpack_public_path__ + "static/media/menu.6e141ac7.svg";